<div class="centred">
    <div class="logout-card">
        <div class="card-item">
            <img ngSrc="./assets/dark-logo.png" alt="department logo" class="logo" height="148" width="600" priority>
        </div>
        <div class="card-item">
            <h1>Signed Out</h1>
        </div>
        <div class="card-item">
            <p>You've signed out of these services:</p>
            <ul>
                <li>SSBA Data Collection System</li>
            </ul>
        </div>
        <div class="card-item">
            <p>You accessed these services using your Digital Identity.</p>
        </div>
        <div class="card-item">
            <p>For your privacy and security, remember to close this browser.</p>
        </div>
    </div>
</div>
